var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 2.02588V7.53327C14.6663 8.28 14.6663 8.65337 14.8117 8.93859C14.9395 9.18947 15.1435 9.39344 15.3944 9.52127C15.6796 9.6666 16.0529 9.6666 16.7997 9.6666H22.3071M17.333 16.3332H6.66634M17.333 21.6665H6.66634M9.33301 10.9998H6.66634M14.6663 1.6665H7.73301C5.4928 1.6665 4.37269 1.6665 3.51705 2.10248C2.7644 2.48597 2.15248 3.09789 1.76898 3.85054C1.33301 4.70619 1.33301 5.82629 1.33301 8.0665V21.9332C1.33301 24.1734 1.33301 25.2935 1.76898 26.1491C2.15248 26.9018 2.7644 27.5137 3.51705 27.8972C4.37269 28.3332 5.4928 28.3332 7.73301 28.3332H16.2663C18.5066 28.3332 19.6267 28.3332 20.4823 27.8972C21.235 27.5137 21.8469 26.9018 22.2304 26.1491C22.6663 25.2935 22.6663 24.1734 22.6663 21.9332V9.6665L14.6663 1.6665Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.e3ac1ebc9b40050d2c09c9f1fd71ea21.svg";
export { ForwardRef as ReactComponent };